// extracted by mini-css-extract-plugin
export default {"header":"header--ZKUG06p1Jd","small":"small--N+dSlB5ELI"};